import { ROUTES } from '@/config';
import { Stack } from '@/core/blocks';
import { HtmlMarkup, Typography } from '@/core/ui';
import type { ICup } from '@/types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

type Props = { cup: ICup };

export const Slide1 = ({ cup }: Props) => {
  const { competition_image, title, logo, cup_text, description } = cup;
  const { t } = useTranslation('translation');

  return (
    <div className='h-screen w-full bg-content1 relative'>
      <div className='absolute top-0 left-4'>
        <Stack upperClass='w-[52px] h-[294px]' lowerClass='w-[52px] h-[87px]' />
      </div>
      <div className='flex h-full w-full justify-between'>
        <div className='flex flex-col pl-48'>
          <div className=' py-16'>
            <Typography className='text-chalk text-[30px] leading-[28.5px] tracking-[1.5px]'>
              {title}
            </Typography>

            <div className='w-full h-full flex space-x-12 mt-24'>
              <img src='/cups/slide1/trophy.png' alt='' className='w-[299px] h-[590px]' />
              <div className='flex flex-col space-y-6 max-w-[395px]'>
                <img src={logo.path} alt={logo.caption || ''} className='w-[82px] h-[82px]' />
                <Typography className='uppercase text-chalk font-semibold text-[75px] leading-[70.5px] tracking-[3.5px]'>
                  {title}
                </Typography>
                <div className='flex items-center'>
                  <div className='h-[8.5px] w-[41px] bg-olive' />
                  <div className='h-[8.5px] w-[41px] bg-danger' />
                </div>
                <HtmlMarkup className='text-chalk font-light text-[26px] leading-[29.9px] tracking-[1.3px]'>
                  {cup_text}
                </HtmlMarkup>
              </div>
            </div>
          </div>
          <Link to={ROUTES.CUPS.COMPETITION}>
            <button
              type='button'
              className='text-chalk flex items-center justify-center bg-danger rounded-full h-[72px] px-9'
            >
              <Typography className='text-chalk text-[22.5px] leading-[22px] tracking-normal uppercase'>
                {t('cups.other')}
              </Typography>
            </button>
          </Link>
        </div>
        <div className='flex flex-col space-y-28 justify-end h-full'>
          <HtmlMarkup className='text-chalk max-w-[576px] font-light text-[26px] leading-[29.9px] tracking-[1.3px]'>
            {description}
          </HtmlMarkup>
          <img
            src={competition_image.path}
            alt={competition_image.caption || ''}
            className='w-[864px] h-[504px] object-cover'
          />
        </div>
      </div>
    </div>
  );
};
